import React from "react";
import { ClipboardList, Check } from "lucide-react";
import { useEnquiry } from "../context/EnquiryContext";

// Toggle a product in/out of the enquiry list. Compact card variant + full detail variant.
export default function AddToListButton({ product, qty = 1, variant = "card", className = "" }) {
  const { add, remove, has } = useEnquiry();
  const inList = has(product.id);

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inList) remove(product.id);
    else add(product, qty);
  };

  if (variant === "detail") {
    return (
      <button onClick={toggle} data-testid={`add-to-list-${product.id}`}
              className={`kp-button inline-flex items-center gap-2 rounded-full border px-6 py-3 font-heading text-[14.5px] font-bold transition-transform hover:-translate-y-0.5 ${className}`}
              style={{ borderColor: inList ? "var(--bright-green-strong)" : "var(--line)", background: inList ? "var(--green-100)" : "#fff", color: inList ? "var(--green-900)" : "var(--green-900)" }}>
        {inList ? <Check size={16} style={{ color: "var(--bright-green-strong)" }} /> : <ClipboardList size={16} />}
        {inList ? "In enquiry list" : "Add to enquiry list"}
      </button>
    );
  }

  return (
    <button onClick={toggle} data-testid={`add-to-list-${product.id}`}
            className={`kp-button kp-button--compact inline-flex items-center justify-center gap-1.5 rounded-full border px-3 py-2 font-heading text-[12.5px] font-bold transition-transform hover:-translate-y-0.5 ${className}`}
            style={{ borderColor: inList ? "var(--bright-green-strong)" : "var(--line)", background: inList ? "var(--green-100)" : "#fff", color: "var(--green-900)" }}>
      {inList ? <Check size={14} style={{ color: "var(--bright-green-strong)" }} /> : <ClipboardList size={14} />}
      {inList ? "Added" : "Add to list"}
    </button>
  );
}
